import { IClassname } from '@/lib/shared/model/classname';

export const Internet = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.09302 13.9938C9.48957 11.5973 12.74 10.251 16.1292 10.251C19.5184 10.251 22.7688 11.5973 25.1653 13.9938"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.7791 9.09915C27.1177 7.43764 25.1454 6.11964 22.9746 5.22043C20.8039 4.32122 18.4773 3.8584 16.1277 3.8584C13.7781 3.8584 11.4515 4.32122 9.28075 5.22043C7.11001 6.11964 5.13766 7.43764 3.47632 9.09915"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7056 18.8839C11.4176 18.1718 12.2629 17.6069 13.1932 17.2215C14.1236 16.8361 15.1207 16.6377 16.1278 16.6377C17.1348 16.6377 18.1319 16.8361 19.0623 17.2215C19.9926 17.6069 20.838 18.1718 21.55 18.8839"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.1653 13.9938C22.7688 11.5973 19.5184 10.251 16.1292 10.251C12.74 10.251 9.48957 11.5973 7.09302 13.9938"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5512 18.8839C20.8392 18.1718 19.9939 17.6069 19.0635 17.2215C18.1332 16.8361 17.136 16.6377 16.129 16.6377C15.122 16.6377 14.1248 16.8361 13.1945 17.2215C12.2641 17.6069 11.4188 18.1718 10.7068 18.8839"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.572 25.5842C13.572 25.9198 13.6381 26.2521 13.7666 26.5622C13.895 26.8723 14.0833 27.1541 14.3206 27.3914C14.5579 27.6287 14.8397 27.817 15.1498 27.9454C15.4599 28.0739 15.7922 28.14 16.1279 28.14C16.4635 28.14 16.7958 28.0739 17.1059 27.9454C17.416 27.817 17.6978 27.6287 17.9351 27.3914C18.1724 27.1541 18.3607 26.8723 18.4891 26.5622C18.6176 26.2521 18.6837 25.9198 18.6837 25.5842C18.6837 24.9063 18.4144 24.2562 17.9351 23.7769C17.4558 23.2976 16.8057 23.0283 16.1279 23.0283C15.45 23.0283 14.7999 23.2976 14.3206 23.7769C13.8413 24.2562 13.572 24.9063 13.572 25.5842Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
